// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c74a0308","453":"1bd2597e","667":"e4482616"}[chunkId] + ".chunk.js";
};